import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { getToken } from "../../utils/getToken";

export const useGetCustomerOrderHistoryQuery = (id: string) => {
  const token = getToken();

  return useQuery({
    queryKey: ["getCustomerOrderHistoryQuery", id],
    queryFn: () =>
      axiosInstance
        .get(`customers/${id}/order-history`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),
    enabled: !!token && !!id,
  });
};
